import { withTranslation } from 'react-i18next'
import Offer from './Offer'

export default withTranslation()(Offer)
